<template lang="pug">
.redemption-code-sure-container(@touchmove.prevent)
  .code-block
    .receive-success 确定选择该礼品吗？领取后无法
    .receive-success 更换为其他礼品哦~
    .btn-block
      .left-btn(@click="closeModal") 再想想
      .right-btn(@click="goRecevice") 确认领取
  .shadow
  </template>

<script>

export default {
  props: {
    successOver: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      clipboard: null,
    };
  },
  mounted() {
  },
  destroyed() {
    if (this.clipboard) {
      this.clipboard.destroy();
      this.clipboard = null;
    }
  },
  methods: {
    closeModal() {
      this.$emit('update:show', false);
    },
    goRecevice() {
      this.$emit('openReceive');
      this.closeModal();
    },
  },
};
</script>
<style lang="less" scoped>
.redemption-code-sure-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 222;

  .code-block {
    margin: 2.9rem auto 0;
    z-index: 101;
    position: relative;
    width: 3.2rem;
    height: 1.56rem;
    background: #fff;
    border-radius: 0.2rem;
    padding-top: 0.28rem;

    .receive-success {
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-size: 0.18rem;
      font-weight: 500;
      text-align: center;
      margin: 0 auto;
    }

    .btn-block {
      margin-top: 0.2rem;
      display: flex;
      justify-content: space-between;
      .left-btn {
        width: 1.4rem;
        height: 0.4rem;
        background: #f0f3f5;
        line-height: 0.4rem;
        text-align: center;
        border-radius: 0.08rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-size: 0.16rem;
        font-weight: 400;
        color: #5a6066;
        margin-left: 0.16rem;
      }
      .right-btn {
        width: 1.4rem;
        height: 0.4rem;
        background: #08f;
        line-height: 0.4rem;
        text-align: center;
        border-radius: 0.08rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-size: 0.16rem;
        font-weight: 500;
        color: #fff;
        margin-right: 0.16rem;
      }
    }
  }

  .shadow {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 100;
  }
}
</style>
